<div class="flex justify-space-between mt-20">
    <div class="search-box"></div>
    <div class="flex justify-flex-end width-70-p">
        <div class="date-filter mr-20"></div>
        <div class="date-filter"></div>
    </div>
</div>
<div class="Rectangle-1551 mt-20" *ngFor="let item of [1,2]">
    <div class="flex justify-space-between">
        <div class="small-grid"></div>
        <div class="small-grid"></div>
        <div class="small-grid"></div>
        <div class="small-grid"></div>
    </div>
    <div class="post">
        <div class="avatar"></div>
        <div class="container">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
        </div>
    </div>
</div>